<template>
  <div>
    <base-header class="pb-6">
      <b-row aling-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">数据</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <!-- <label v-for="color in eventColors"
                   :key="color"
                   class="btn"
                   :class="[color, {'active focused': model.className === color}]">
              <input v-model="model.className" type="radio" name="event-tag" :value="color" autocomplete="off">
            </label> -->
    </base-header>
    <!--Charts-->
    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12">
          <card type="default" header-classes="bg-transparent">
            <b-row align-v="center" slot="header">
              <b-col>
                <h5 class="h3 text-white mb-0">资产收益（USDT）</h5>
              </b-col>
              <b-col>
               <b-nav class="nav-pills justify-content-end">
                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="bigLineChart.activeIndex === 0"
                    @click.prevent="initBigChart(0)"
                  >
                    <span class="d-none d-md-block">全部</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>

                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="bigLineChart.activeIndex === 1"
                    @click.prevent="initBigChart(1)"
                  >
                    <span class="d-none d-md-block">倚天</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>

                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="bigLineChart.activeIndex === 2"
                    @click.prevent="initBigChart(2)"
                  >
                    <span class="d-none d-md-block">九阳神功</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>

                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="bigLineChart.activeIndex === 3"
                    @click.prevent="initBigChart(3)"
                  >
                    <span class="d-none d-md-block">一阳指</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>

                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="bigLineChart.activeIndex === 4"
                    @click.prevent="initBigChart(4)"
                  >
                    <span class="d-none d-md-block">屠龙</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>

                    <b-nav-item
                    link-classes="py-2 px-3"
                    :active="bigLineChart.activeIndex === 5"
                    @click.prevent="initBigChart(5)"
                  >
                    <span class="d-none d-md-block">屠龙T</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>

                  <b-nav-item
                    link-classes="py-2 px-3"
                    :active="bigLineChart.activeIndex === 6"
                    @click.prevent="initBigChart(6)"
                  >
                    <span class="d-none d-md-block">鸳鸯刀</span>
                    <span class="d-md-none">W</span>
                  </b-nav-item>
                </b-nav> 
              </b-col>
            </b-row>
            <line-chart
              :height="350"
              ref="bigChart"
              :chart-data="bigLineChart.chartData"
              :extra-options="bigLineChart.extraOptions"
            >
            </line-chart>
          </card>
        </b-col>
      </b-row>
      <!-- End charts-->

      <b-row aling-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0">
            {{ lastDealTitle }}
          </h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <base-button @click="getBI(-1)" size="sm" type="neutral"
            >最近1天</base-button
          >
          <base-button @click="getBI(-3)" size="sm" type="neutral"
            >最近3天</base-button
          >

          <base-button @click="getBI(-7)" size="sm" type="neutral"
            >最近7天</base-button
          >

          <base-button @click="getBI(-15)" size="sm" type="neutral"
            >最近15天</base-button
          >

          <base-button @click="getBI(-30)" size="sm" type="neutral"
            >最近30天</base-button
          >
        </b-col>
      </b-row>

      <b-row>
        <b-col v-for="bi in lastDeal" xl="4" md="6">
          <stats-card
            :title="
              bi.platformName +
              bi.symbol +
              ' - ' +
              strategyTypes[bi.strategy_type]
            "
            type="gradient-red"
            :sub-title="bi.totalProfit | formatPrice"
          >
            <template slot="footer">
              <span class="text-nowrap">盈利{{ bi.winCount }}次：</span>
              <span class="text-success mr-2">
                {{ bi.winProfit | formatPrice }}
              </span>

              <span class="text-nowrap">亏损{{ bi.loseCount }}次：</span>
              <span class="text-danger mr-2"
                >{{ bi.loseProfit | formatPrice }}
              </span>

              <span class="text-nowrap">手续费：</span>
              <span class="text-danger mr-2"
                >{{ bi.totalFee | formatPrice }}
              </span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import biApi from "../../api/bi";

// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
  import { Charts } from "@/components/Charts/config";

export default {
  components: {
    // ActivityFeed,
    LineChart,
    BarChart,
    BaseProgress,
    RouteBreadCrumb,
    StatsCard,
  },
  data() {
    return {
      lastDeal: [],
      lastDealTitle: "",
      dayProfit: [],
      strategyTypes: {},

      bigLineChart: {
        allData: [[0, 0, 0, 0, 0, 0, 0]],
        activeIndex: 0,
        extraOptions: chartConfigs.blueChartOptions,
        chartData: {
          datasets: [
            {
              label: "Performance",
              data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
            },
          ],
          labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        },
      },
    };
  },
  filters: {
    formatPrice(val) {
      return Math.floor(val * 1000) / 1000 + "";
    },
  },
  methods: {
    initBigChart(index) {
      console.log("++++++++++++++++++++++++++++");
      let chartData = {
        datasets: [
          {
            label: "盈亏",
            data: this.bigLineChart.allData[index],
          },
        ],
        labels: this.bigLineChart.labels,
      };
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    },
    /**
     * 获取用户账户信息
     */
    async getBI(day) {
      const res = await biApi.getBI({ day });

      if (res && res.code == 200) {
        const { data } = res;
        this.dayProfit = data.dayProfit;
        this.strategyTypes = data.strategyTypes;
        this.lastDeal = data.lastDeal;

        let profits = [];
        let profits1 = [];

        let profitsYT = [];
        let profitsYT1 = [];

        let profitsTL = [];
        let profitsTL1 = [];

        let profitsTLT = [];
        let profitsTLT1 = [];

        let profitsJY = [];
        let profitsJY1 = [];

        let profitsYYZ = [];
        let profitsYYZ1 = [];

        let profitsYYD = [];
        let profitsYYD1 = [];


        let labels = [];
        for (let i = 0; i < data.dayProfit.length; i++) {
          let item = data.dayProfit[i];
          profits.push(item.total_profit);
          profits1.push(
            parseFloat(item.total_profit) - parseFloat(item.total_fee)
          );
          labels.push(item.date.substring(5));

          let itemJY = data.dayProfitJY[i];
          profitsJY.push(itemJY.total_profit);
          profitsJY1.push(
            parseFloat(itemJY.total_profit) - parseFloat(itemJY.total_fee)
          );

          let itemYYZ = data.dayProfitYYZ[i];
          profitsYYZ.push(itemYYZ.total_profit);
          profitsYYZ1.push(
            parseFloat(itemYYZ.total_profit) - parseFloat(itemYYZ.total_fee)
          );

          let itemYT = data.dayProfitYT[i];
          profitsYT.push(itemYT.total_profit);
          profitsYT1.push(
            parseFloat(itemYT.total_profit) - parseFloat(itemYT.total_fee)
          );


          let itemTL = data.dayProfitTL[i];
          profitsTL.push(itemTL.total_profit);
          profitsTL1.push(
            parseFloat(itemTL.total_profit) - parseFloat(itemTL.total_fee)
          );

          let itemTLT = data.dayProfitTLT[i];
          profitsTLT.push(itemTLT.total_profit);
          profitsTLT1.push(
            parseFloat(itemTLT.total_profit) - parseFloat(itemTLT.total_fee)
          );

          let itemYYD = data.dayProfitYYD[i];
          profitsYYD.push(itemYYD.total_profit);
          profitsYYD1.push(
            parseFloat(itemYYD.total_profit) - parseFloat(itemYYD.total_fee)
          );

        }

        this.bigLineChart.allData = [profits1, profitsYT1,profitsJY1,profitsYYZ1,profitsTL1,profitsTLT1,profitsYYD1];
        this.bigLineChart.labels = labels;

        let chartData = {
          datasets: [
            {
              label: "全部",
              data: profits1,
             
            },
            // {
            //   label: "倚天",
            //   data: profitsYT1,
            // },
            // {
            //   label: "屠龙",
            //   data: profitsTL1,
            // },
            // {
            //   label: "屠龙T",
            //   data: profitsTLT1,
            // },
            
          ],
          labels: labels,
          
        };

        this.bigLineChart.chartData = chartData;
        // this.bigLineChart.activeIndex = index;

        this.lastDealTitle = `最近` + Math.abs(day) + `天交易统计`;
      }
    },
  },
  mounted() {
    this.getBI(-7);
  },
};
</script>
<style></style>
